var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Skeleton',_vm._l((4),function(index){return _c('SkeletonItem',{key:index},[_c('div',{staticClass:"rm-mb--8",staticStyle:{"height":"44px","border-radius":"5px"}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }